import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer';
import { ContainerWrapper, Title, CardWrapper, CardsList } from './style';
import useCurrentLang from '@/hooks/useCurrentLang';
import { Link } from 'react-router-dom';
import useResize from '@/hooks/useResize';
import { getBlogSummary } from '@/api/frontData.api';
import PATH from '@/router/path';
import { LoadingPage } from '@/layout';
import { sify } from 'chinese-conv/dist'
import { errorHandler } from '@/utils/toastHandler';
import { Helmet } from 'react-helmet';
import LocalizedPageLinks from '@/components/SEO/LocalizedPageLinks';

const Blog = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();
  const { isTablet, isMobile } = useResize();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<Blog[]>([]);

  const initData = async () => {
    setIsLoading(true);
    try {
      const res = (await getBlogSummary()).data;

      // 按照weight排序, 0為最優先, 若weight相同則按照created_at排序
      const sortedBlog = res.sort((a, b) => {
        return b.weight - a.weight;
      });
      setData(sortedBlog);
    } catch (error) {
      console.log(error);
      errorHandler(t('error.server'));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initData();
  }, [lang]);

  return (
    <>
      <Helmet>
        <title>{`${t('pages.index.Blog.title')} | eBRAM`}</title>
        <meta itemProp="name" content={`${t('pages.index.Blog.title')} | eBRAM`} />
        <meta property="og:title" content={`${t('pages.index.Blog.title')} | eBRAM`} />
        <meta name="twitter:title" content={`${t('pages.index.Blog.title')} | eBRAM`} />
        <meta name="description" content={t('seo.blog.metaDescription')} />
        <meta property="og:description" content={t('seo.blog.metaDescription')} />
        <meta name="twitter:description" content={t('seo.blog.metaDescription')} />
      </Helmet>
      <LocalizedPageLinks pagePath="/Blog" />
      <LoadingPage isLoading={isLoading} />
      <ContainerWrapper>
        <Title>{t('pages.index.Blog.title')}</Title>
        <CardsList isTablet={isTablet} isMobile={isMobile}>
          {data.map((blog, index) => (
            <CardWrapper key={blog.title + blog.title_en} isTablet={isTablet} isMobile={isMobile}>
              <div className="pic">
                <img src={blog.img_url} alt="" loading={index === 0 ? 'eager' : 'lazy'} decoding="async" />
              </div>
              <div className="content">
                <h2>{lang === 'en' ? blog.title_en : lang === 'tc' ? blog.title : sify(blog.title)}</h2>
                <p>{lang === 'en' ? blog.description_en : lang === 'tc' ? blog.description : sify(blog.description)}</p>
                <Link to={PATH.blog.detail.replace(':lang', lang).replace(':cus_title', blog.cus_title)}>{t('buttons.howtoUse')}</Link>
              </div>
            </CardWrapper>
          ))}
        </CardsList>
      </ContainerWrapper>
      <Footer />
    </>
  );
};

export default Blog;
